import React, { useCallback, useEffect } from "react";
import Grid from "@mui/material/Grid";
import {
  StripeTextFieldNumber,
  StripeTextFieldExpiry,
  StripeTextFieldCVC,
} from "components/CreditCardForm/StripeForm/CommonTextFields";

export default function StripeCreditCardDetail({
  handleCardError,
  cardDetails,
  setCardDetails,
}) {
  const { cardNumberError, expiredError, cvcError } = cardDetails;

  const onElementChange = useCallback(
    (field, errorField) => {
      return ({ complete, error = { message: null } }) => {
        setCardDetails((prev) => {
          return {
            ...prev,
            [field]: complete,
            [errorField]: error.message,
          };
        });
      };
    },
    [cardDetails, setCardDetails]
  );

  useEffect(() => {
    if (
      cardNumberError != null ||
      expiredError != null ||
      cvcError != null ||
      !cardDetails.expiredComplete ||
      !cardDetails.cardNumberComplete ||
      !cardDetails.cvcComplete
    ) {
      handleCardError(
        cardNumberError ||
          expiredError ||
          cvcError ||
          ((!cardDetails.expiredComplete ||
            !cardDetails.cardNumberComplete ||
            !cardDetails.cvcComplete) &&
            "Payment information is required")
      );
    } else {
      handleCardError(false);
    }
  }, [cardNumberError, cvcError, expiredError, handleCardError, cardDetails]);

  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid item xs={12} md={12}>
        <StripeTextFieldNumber
          error={Boolean(cardNumberError)}
          labelErrorMessage={cardNumberError}
          onChange={onElementChange("cardNumberComplete", "cardNumberError")}
        />
      </Grid>
      <Grid item xs={6} sm={6} md={6} sx={{ mt: 2 }}>
        <StripeTextFieldExpiry
          error={Boolean(expiredError)}
          labelErrorMessage={expiredError}
          onChange={onElementChange("expiredComplete", "expiredError")}
        />
      </Grid>
      <Grid item xs={6} sm={6} md={6} sx={{ mt: 2, mb: 2 }}>
        <StripeTextFieldCVC
          error={Boolean(cvcError)}
          labelErrorMessage={cvcError}
          onChange={onElementChange("cvcComplete", "cvcError")}
        />
      </Grid>
    </Grid>
  );
}
